// ============================================================
// PLUMME 2.0 — runtime contracts + locale-aware formatters
// ============================================================
// Foretaksdata kommer utelukkende fra aktivt foretaks backend-state. Globale
// standardverdier er bevisst tomme slik at design-/demodata aldri kan bli vist
// eller lagret som ekte foretaksdata ved treg eller manglende initialisering.
const nf={format:(n)=>PlummeI18n.number(n)};
const fmt =(n)=> PlummeI18n.money(n,{decimals:0});
const fmt0=(n)=> PlummeI18n.signed(Math.round(Number(n)||0));
const fmtDec=(n)=> PlummeI18n.money(n,{decimals:2});
const pct=(n)=> PlummeI18n.percent(n);

const COMPANY={name:'',orgnr:'',konto:'',addr:'',email:''};
const CLIENT_COMPANY={};
const companyFor=(clientId)=>CLIENT_COMPANY[clientId]||COMPANY;

const CUSTOMERS=[];
const SUPPLIERS=[];
const PRODUCTS=[];
const INVOICES=[];
const VOUCHERS=[];

// Forbrukerne indekserer rett inn i denne arrayen, så den oppdateres på plass
// ved språkbytte i stedet for å byttes ut med en ny referanse.
const MONTHS=['Jan','Feb','Mar','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Des'];
const refreshMonths=()=>{for(let i=0;i<12;i+=1)MONTHS[i]=PlummeI18n.t('month.short.'+(i+1),MONTHS[i]);};
refreshMonths();
window.addEventListener(PlummeI18n.CHANGE_EVENT,refreshMonths);

const CHART=[];
const DEADLINES=[];
const VAT={skyldig:0,betalt:0,inngaaende:0,utgaaende:0,tilgode:0,codes:[]};

Object.assign(window,{nf,fmt,fmt0,fmtDec,pct,COMPANY,CUSTOMERS,SUPPLIERS,PRODUCTS,INVOICES,VOUCHERS,MONTHS,CHART,DEADLINES,VAT});
